module.exports = __webpack_public_path__ + "assets/avatar-philbone.66c9d1df.svg";